import React, { useEffect, useState, useContext, useRef } from 'react'
import BankIDApi from '../services/api/BankID'
import { PublicIndexContext } from '../context/PublicIndexContext'
import QRCode from 'react-qr-code'
import { ClipLoader } from 'react-spinners'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const ErrorMessage = ({ message }) => {
  const { t } = useTranslation()

  return (
    <p className='text-danger'>{t(message)}</p>
  )
}

const wrapperStyling = {
  height: 'auto',
  maxWidth: '70%',
  backgroundColor: '#FFF',
  marginBottom: '10px',
  marginTop: '10px'
}

const qrCodeStyling = {
  height: 'auto',
  maxWidth: '100%',
  width: '100%'
}
const BankIDQRCode = ({ orderRef, show, onCancel }) => {
  const abortController = new AbortController()
  const context = useContext(PublicIndexContext)
  const responseStatus = useRef(null)
  const isShowing = useRef(false)
  const [value, setValue] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    isShowing.current = show

    if (error !== null || isShowing.current === false) {
      return () => null
    }

    const intervalId = setInterval(() => {
      if (orderRef !== undefined && orderRef !== null) {
        getQrCodeValue(orderRef)
      }
    }, 1000)

    return () => clearInterval(intervalId)
  }, [show, error])

  async function getQrCodeValue () {
    const bankID = new BankIDApi()
    bankID.qrCode(context.customerId, orderRef, abortController.signal)
      .then(response => {
        responseStatus.current = response.status
        return response.json()
      })
      .then(data => {
        if (responseStatus.current === 200) {
          setValue(data[0])
        } else {
          cancel(data)
        }
      })
      .catch(error => {
        cancel(error)
      })
  }

  function cancel (data = null) {
    if (data !== null) {
      setError(data.message)
    } else {
      console.error(data)
    }

    setValue(null)
    isShowing.current = false
    onCancel()
    abortController.abort()
  }

  if (value !== null) {
    return (
      <div className="centered-row mt-3">
        <div style={wrapperStyling}>
          <QRCode value={value} size={184} style={qrCodeStyling} viewBox={'0 0 184 184'}/>
        </div>
      </div>
    )
  } else {
    if (error !== null) {
      return <ErrorMessage message={error} />
    } else {
      return (
        <div>
          <div className="centered-row mt-3">
            <div className="col-12 text-center">
              <span className="paragraph-regular-16">Genererar QR-kod...</span>
            </div>
          </div>
          <ClipLoader size={75} color={'#BF33BD'} loading={true} />
        </div>
      )
    }
  }
}

export default BankIDQRCode

BankIDQRCode.propTypes = {
  show: PropTypes.bool.isRequired,
  orderRef: PropTypes.string,
  onCancel: PropTypes.func.isRequired
}

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired
}
